const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-completed",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-completed1",
    serifid: "iconB-progress-completed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c-0,-6.071 4.929,-11 11,-11Zm0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.183,9.622l-0,4.756c-0,1.562 -1.136,2.81 -2.504,2.81l-5.358,-0c-1.368,-0 -2.504,-1.248 -2.504,-2.81l0,-4.756c0,-1.564 1.136,-2.81 2.504,-2.81l5.358,0c1.368,0 2.504,1.246 2.504,2.81Zm-6.158,-0.588l-1.231,0l-0.473,0c-0.275,0 -0.472,0.275 -0.472,0.588l-0,4.756c-0,0.314 0.197,0.588 0.472,0.588l5.358,-0c0.275,-0 0.472,-0.274 0.472,-0.588l0,-4.756c0,-0.313 -0.197,-0.588 -0.472,-0.588l-0.473,0l-1.231,0c0.016,0.072 0.025,0.147 0.025,0.223l0,1.743c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1l0,-1.743c0,-0.076 0.009,-0.151 0.025,-0.223Zm-8.162,9.177c-0.369,-0.505 -0.142,-1.076 0.208,-1.331c0.331,-0.242 1.049,-0.341 1.462,0.213c1.761,2.36 4.423,3.906 7.4,3.906c5.004,0 9.061,-4.014 9.061,-9.019c-0,-4.74 -3.665,-8.589 -8.301,-8.98c-0.531,-0.035 -0.943,-0.475 -0.944,-1.007l-0,-0.003c-0,-0.276 0.125,-0.54 0.325,-0.729c0.201,-0.188 0.471,-0.286 0.745,-0.269c0.002,-0 0.003,-0 0.004,-0c5.68,0.47 10.171,5.187 10.171,10.988c0,6.109 -4.952,11.02 -11.061,11.02c-3.647,0 -7.004,-1.826 -9.068,-4.786c-0.001,-0.001 -0.001,-0.002 -0.002,-0.003Z",
    style: {
      fill: "#01b800"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressCompleted);
export default __webpack_public_path__ + "static/media/iconB-progress-completed.3d25bfd556d67a4bd1562e733cebae33.svg";
export { ForwardRef as ReactComponent };